module.exports = "<app-widgets-summary object=$ctrl.archive type=archive></app-widgets-summary> <button type=button class=\"btn btn-primary\" ng-click=$ctrl.edit() translate>Edit</button> <button type=button class=\"btn btn-default\" ng-click=$ctrl.delete() ng-disabled=!$ctrl.isAdmin translate>Delete </button> <br> <br> <ui-view></ui-view> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/archive/view/component_partial.html
// module id = 399
// module chunks = 0